import { DipPageState } from './types';

const useDipPage = (id: string = 'layoutScroll'): DipPageState => {
  const dipPageGoToTop = (referenceId?: string, offset: number = 0) => {
    let toTop = 0;
    const layoutScroll = document.getElementById(id);

    if (layoutScroll) {
      const layoutContent = document.getElementById('dipLayoutContent');

      if (layoutContent) {
        if (referenceId) {
          const layoutContentRect = layoutContent.getBoundingClientRect();

          const referenceElement = document.getElementById(referenceId);

          if (referenceElement) {
            const referenceElementRect = referenceElement.getBoundingClientRect();

            toTop = referenceElementRect.top - layoutContentRect.top + offset;
          }
        }

        layoutScroll.scroll({ top: toTop, behavior: 'smooth' });
      }
    }
  };

  return {
    dipPageGoToTop,
  };
};

export default useDipPage;
